export default {
    q1:{
        en:'',
        tc:'',
        sc:'',
    },
    q1_a:{
        en:`21whitfield (henceforth, “Hotel”) has established a personal information protection policy as 
            stated hereafter, has created a framework for personal information protection, and insists on 
            all employees recognizing the importance of personal information protection and initiatives for 
            each and every guest under all circumstances. The following outlines the hotel’s effort to 
            promote personal information protection.`,
        tc:'21whitfield (以下簡稱「酒店」）已按照以下所述制定個人資料保護政策，建立了個人資料保護框架，並堅持所有員工在任何情況下都要認識到個人資料保護的重要性，以及為每位客人採取的保護措施。以下概述了酒店在促進個人資料保護方面的努力。',
        sc:'21whitfield (以下简称「酒店」）已按照以下所述制定个人资料保护政策，建立了个人资料保护框架，并坚持所有员工在任何情况下都要认识到个人资料保护的重要性，以及为每位客人采取的保护措施。以下概述了酒店在促进个人资料保护方面的努力。',

    },
    q2:{
        en:'personal information management',
        tc:'個人資料管理',
        sc:'个人资料管理',
    },
    q2_a:{
        en:`In order to keep customers’ personal information accurate and up to date, and to prevent 
        unauthorized access, loss, damage, falsification, leakage, etc., to personal information, we take 
        necessary measures such as maintaining a security system / creating a management system / 
        and holding thorough employee training about safety measures and rigorous general 
        management of personal information.`,
        tc:`為了保持客戶個人資料的準確性和及時性，並防止未經授權的訪問、丟失、損壞、偽造、洩漏等情況發生，我們採取必要措施，如維護安全系統/創建管理系統/以及對員工進行關於安全措施的全面培訓和嚴格的個人資料一般管理。`,
        sc:`为了保持客户个人资料的准确性和及时性，并防止未经授权的访问、丢失、损坏、伪造、泄漏等情况发生，我们采取必要措施，如维护安全系统/创建管理系统/以及对员工进行关于安全措施的全面培训和严格的个人资料一般管理。`,
    },
    q3:{
        en:'use of personal information',
        tc:'個人資料的使用',
        sc:'个人资料的使用',
    },
    q3_a:{
        en:`Personal information obtained from customers is used for notifications from the company, 
            assistance with tasks, and responding to questions via methods including sending e-mails 
            and assistance notifications.`,
        tc:'從客戶獲取的個人資料用於公司通知、任務協助和通過電子郵件發送和協助通知等方法回應問題。',
        sc:'从客户获取的个人资料用于公司通知、任务协助和通过电子邮件发送和协助通知等方法回应问题。',
    },
    q4:{
        en:'disclosure of or providing personal information to\n a third party is strictly prohibited',
        tc:'嚴禁向第三方披露或提供個人資料',
        sc:'严禁向第三方披露或提供个人资料',
    },
    q4_a:{
        en:`We manage personal information obtained from customers appropriately, and do not disclose 
            personal information to a third party except in the following situations:`,
        tc:'我們適當地管理從客戶獲取的個人資料，除以下情況外，不會向第三方披露個人資料：',
        sc:'我们适当地管理从客户获取的个人资料，除以下情况外，不会向第三方披露个人资料：',
    },
    q4_a1:{
        en:`After receiving consent from the guest.`,
        tc:'獲得客人同意後。',
        sc:'获得客人同意后。',
    },
    q4_a2:{
        en:`To an outsourced business which provides a service requested by the guest`,
        tc:'向提供客人所要求服務的外包業務。',
        sc:'向提供客人所要求服务的外包业务。',
    },
    q4_a3:{
        en:`When disclosure is required by law`,
        tc:'法律要求披露時。',
        sc:'法律要求披露时。',
    },
    q5:{
        en:'personal information security measures.',
        tc:'個人資料安全措施',
        sc:'个人资料安全措施',
    },
    q5_a:{
        en:'We take appropriate security measures to ensure the accuracy and safety of personal information.',
        tc:'我們採取適當的安全措施，確保個人資料的準確性和安全性。',
        sc:'我们采取适当的安全措施，确保个人资料的准确性和安全性。',
    },
    q6:{
        en:'identity verification',
        tc:'身份驗證',
        sc:'身份验证',
    },
    q6_a:{
        en:'If you wish for your personal information to be validated, corrected, or deleted, we will comply after confirming your identity.',
        tc:'如果您希望驗證、更正或刪除您的個人資料，我們將在確認您的身份後遵守。',
        sc:'如果您希望验证、更正或删除您的个人资料，我们将在确认您的身份后遵守。',
    },
    q7:{
        en:'compliance with or revision of laws and standards',
        tc:'遵守或修訂法律和標準',
        sc:'遵守或修订法律和标准',
    },
    q7_a:{
        en:'We comply with the laws of Hong Kong as well as with other standards applicable to the storing of personal information. We revise this policy as needed to improve and better compliance whenever possible.',
        tc:'我們遵守香港法律以及其他適用於個人資料存儲的標準。在可能的情況下根據需要我們將修訂此政策，以改進並更好地遵守。',
        sc:'我们遵守香港法律以及其他适用于个人资料存储的标准。在可能的情况下我们将根据需要修订此政策，以改进并更好地遵守。',
    },
    q8:{
        en:'contact',
        tc:'聯繫',
        sc:'联系',
    },
    q8_a:{
        en:`Please contact us at the following location for details on our handling of personal information.\n21whitfield No. 21, Whitfield Road, Causeway Bay, Hong Kong Island, Hong KongPhone number ： +852 39948585`,
        tc:'如需了解我們處理個人資料的詳情，請聯繫以下地點：\n21whitfield 香港島銅鑼灣威菲路道21號 電話號碼：+852 39948585',
        sc:'如需了解我们处理个人资料的详情，请联系以下地点：\n21whitfield 香港岛铜锣湾威菲路道21号 电话号码：+852 39948585',
    },

}